export const LocationRefFragment = /* GraphQL */ `
	fragment LocationRefFragment on Location {
		_id
		name
		type
		hash
	}
`;
